import { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { UserActionCreators } from '../../../../Store/ActionCreators/UserActionCreators';
import { validateSignInFields } from '../../../../Validation/Authentication/SignIn';
import { mapSignInPostRequestValues } from '../../../../BusinessLogic/Handlers/Authentication';
import { areObjectsEqual } from '../../../../Utils';

class SignInFormContainer extends Component {
    state = {
        email: '',
        password: '',
        validationErrors: {},
    };

    componentDidUpdate(prevProps) {
        if (!areObjectsEqual(prevProps.authenticationErrors, this.props.authenticationErrors))
            this.setState({ validationErrors: this.props.authenticationErrors });
    }

    handleInputChange = event => this.setState({ [event.target.name]: event.target.value });
    clearValidationErrors = () => this.setState({ validationErrors: {} });
    setValidationErrors = validationErrors => this.setState({ validationErrors });
    checkButtonDisabled = () => this.state.email === '' || this.state.password === '';

    handleSubmit = event => {
        event.preventDefault();

        this.clearValidationErrors();
        const { validationErrors, ...credentials } = this.state;
        const { errors, isValidationPassed } = validateSignInFields(this.state);

        if (isValidationPassed)
            this.props.signIn(mapSignInPostRequestValues(credentials), url => (window.location.href = url));
        else this.setValidationErrors(errors);
    };

    render() {
        const { isSigningIn } = this.props;
        const isSubmitButtonDisabled = this.checkButtonDisabled() || isSigningIn;

        return this.props.renderForm({
            ...this.state,
            handleSubmit: this.handleSubmit,
            handleChange: this.handleInputChange,
            isSubmitButtonDisabled,
            isRequestProcessing: isSigningIn,
        });
    }
}

const mapStateToProps = ({ user: { statuses, authenticationErrors } }) => ({
    isSigningIn: statuses.isUserSigningIn,
    authenticationErrors,
});

const mapDispatchToProps = dispatch => ({
    signIn: (credentials, completion) => dispatch(UserActionCreators.signInUserRequest(credentials, completion)),
});

SignInFormContainer.defaultProps = {
    isSigningIn: false,
    authenticationErrors: {},
};

SignInFormContainer.propTypes = {
    isSigningIn: PropTypes.bool.isRequired,
    authenticationErrors: PropTypes.object.isRequired,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(SignInFormContainer);



// WEBPACK FOOTER //
// ./src/UI/Containers/FormContainers/Authentication/SignInForm.js